<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30">
    <div class="card bd-gray-400">
      <table class="table mg-b-0 table-contact bill data-table">
        <thead>
          <tr>
            <th>{{ $t("financial.报表名称 / 编号 / 统计时段") }}</th>
            <th>
              {{ $t("financial.统计方式") }}
              <i
                class="ion-ios-help-outline tx-16 tx-info"
                data-toggle="tooltip-primary"
                data-placement="top"
                data-html="true"
                :data-original-title="`
              ${$t('financial.以库存SKU成本统计：')}<br> 
              ${$t(
                'financial.订单毛利 = 订单商品总额 - 库存SKU成本，'
              )} <br> <br>
              ${$t('financial.以原料成本统计：')}<br>
              ${$t('financial.订单毛利 = 订单商品总额 - 原料成本')}`"
              ></i>
            </th>
            <th class="tx-center">{{ $t("financial.订单数量") }}</th>
            <th>{{ $t("financial.状态") }}</th>
            <th>{{ $t("financial.成本(元)") }}</th>
            <th class="tx-center">
              {{ $t("financial.订单总收入(元) / 订单毛利(元)") }}
              <i
                class="ion-ios-help-outline tx-16 tx-info"
                data-toggle="tooltip-primary"
                data-placement="top"
                data-html="true"
                :data-original-title="`
              ${$t('financial.以库存SKU成本统计：')}<br> 
              ${$t(
                'financial.订单毛利 = 订单商品总额 - 库存SKU成本，'
              )} <br> <br>
              ${$t('financial.以原料成本统计：')}<br>
              ${$t('financial.订单毛利 = 订单商品总额 - 原料成本')}`"
              ></i>
            </th>
            <th>
              {{ $t("financial.总利润(元) / 利润率") }}
              <i
                class="ion-ios-help-outline tx-16 tx-info"
                data-toggle="tooltip-primary"
                data-placement="top"
                data-html="true"
                :data-original-title="`${$t(
                  'financial.总利润 = 订单毛利 -物流成本 -用工成本 -场地成本 -其他成本'
                )} <br>
              ${$t('financial.利润率 = 总利润 / 总收入 * 100%')}`"
              ></i>
            </th>
            <th class="tx-center">{{ $t("financial.操作日志 / 创建日期") }}</th>
            <th>{{ $t("financial.操作") }}</th>
          </tr>
        </thead>
        <tbody class="tx-12">
          <tr v-for="item in items" :key="item.id">
            <td class="valign-middle">
              <div class="mg-b-5 tx-white">
                {{ item.name }}
                <a
                  href="javascript:;"
                  class="mg-l-5 tx-info"
                  @click="modiName(item)"
                  ><i class="fa fa-pencil"></i
                ></a>
              </div>
              <div class="mg-b-5 tx-white">{{ item.code }}</div>
              <div class="tx-white">
                {{ item.dateFrom | dateFormat }} ~
                {{ item.dateTo | dateFormat }}
              </div>
            </td>
            <td class="valign-middle">
              <div class="tx-white">{{ typeArr[item.type] }}</div>
            </td>
            <td class="valign-middle tx-center">
              <a
                class="tx-info tx-underline"
                href="javascript:;"
                @click="getOrder(item.id)"
              >
                {{ item.orderCnt }}
              </a>
            </td>
            <td class="valign-middle">
              <div class="mg-b-5" :class="statusClass[item.status]">
                {{ $t($dict.profitStatus[item.status]) }}
              </div>
              <div class="mg-b-5 tx-white">{{ item.reasonStr }}</div>
            </td>
            <td class="valign-middle">
              <div class="mg-b-5">
                {{ $t("financial.物流：")
                }}<span class="tx-white mg-r-5">
                  {{
                    item.logisticsCost == "-" ? "-" : "￥ " + item.logisticsCost
                  }}</span
                >
                <i
                  v-if="item.logisticsCost == '-' && item.reasonStr"
                  class="ion-ios-help-outline tx-16 tx-info"
                  data-toggle="tooltip-primary"
                  data-placement="top"
                  :data-original-title="item.reasonStr"
                ></i>
              </div>
              <div class="mg-b-5">
                {{ $t("financial.用工：")
                }}<span class="tx-white">￥{{ item.employeeCost }}</span>
              </div>
              <div class="mg-b-5">
                {{ $t("financial.场地：")
                }}<span class="tx-white">￥{{ item.siteCost }}</span>
              </div>
              <div>
                {{ $t("financial.其他：")
                }}<span class="tx-white">￥{{ item.otherCost }}</span>
              </div>
            </td>
            <td class="valign-middle tx-center">
              <div class="mg-b-5 tx-white">
                {{ item.orderAmount == "-" ? "-" : "￥ " + item.orderAmount }}
                <i
                  v-if="item.orderAmount == '-' && item.reasonStr"
                  class="ion-ios-help-outline tx-16 tx-info"
                  data-toggle="tooltip-primary"
                  data-placement="top"
                  :data-original-title="item.reasonStr"
                ></i>
              </div>
              <div class="tx-white">
                {{ item.grossProfit == "-" ? "-" : "￥ " + item.grossProfit }}
                <i
                  v-if="item.grossProfit == '-' && item.reasonStr"
                  class="ion-ios-help-outline tx-16 tx-info"
                  data-toggle="tooltip-primary"
                  data-placement="top"
                  :data-original-title="item.reasonStr"
                ></i>
              </div>
            </td>
            <td class="valign-middle">
              <div class="mg-b-5">
                <span :class="item.profit | numClass">{{
                  item.profit | formatProfit
                }}</span>
                <i
                  v-if="item.profit == '-' && item.reasonStr"
                  class="mg-l-5 ion-ios-help-outline tx-16 tx-info"
                  data-toggle="tooltip-primary"
                  data-placement="top"
                  :data-original-title="item.reasonStr"
                ></i>
              </div>
              <div>
                <span :class="item.profitRate | numClass">{{
                  item.profitRate | formatRate
                }}</span>
                <i
                  v-if="item.profitRate == '-' && item.reasonStr"
                  class="mg-l-5 ion-ios-help-outline tx-16 tx-info"
                  data-toggle="tooltip-primary"
                  data-placement="top"
                  :data-original-title="item.reasonStr"
                ></i>
              </div>
            </td>
            <td class="valign-middle tx-center">
              <div class="mg-b-5">
                <a
                  :class="
                    item.operateLog && item.operateLog.length
                      ? 'tx-info'
                      : 'tx-gray'
                  "
                  href="javascript:;"
                  @click="showOperateLog(item.operateLog)"
                >
                  <i class="icon ion-chatbox-working tx-20"></i>
                </a>
              </div>
              <div>{{ item.timeCreated }}</div>
            </td>
            <td class="valign-middle">
              <template v-if="item.status != '2' && item.status != '9'">
                <div v-if="item.reason == 1" class="mg-b-5">
                  <router-link
                    class="tx-info"
                    :to="{
                      path: '/order-manager',
                      query: {
                        dateFrom: item.dateFrom,
                        dateTo: item.dateTo,
                        from: 'profit',
                      },
                    }"
                    target="_blank"
                    >{{ $t("financial.查看未全部到货订单") }}
                  </router-link>
                </div>
                <div v-if="item.type != 1 && item.reason == 2" class="mg-b-5">
                  <a
                    class="tx-info"
                    href="javascript:;"
                    @click="setSkus(item, 2)"
                  >
                    {{ $t("financial.设置SKU原料") }}
                  </a>
                </div>
                <div v-if="item.reason == 3" class="mg-b-5">
                  <a
                    class="tx-info"
                    href="javascript:;"
                    @click="setSkus(item, 1)"
                  >
                    {{ $t("financial.绑定库存SKU") }}
                  </a>
                </div>
                <div class="mg-b-5" v-if="isSysRights('Profit.reCalculate')">
                  <a
                    class="tx-info"
                    href="javascript:;"
                    @click="reCalculate(item)"
                    >{{ $t("financial.重新统计") }}</a
                  >
                </div>
              </template>
              <div v-if="item.status != '9'">
                <a
                  v-if="isSysRights('Profit.cancelBySupplier')"
                  class="tx-danger"
                  href="javascript:;"
                  @click="cancelProfit(item)"
                  >{{ $t("financial.作废") }}</a
                >
              </div>
            </td>
          </tr>
          <tr v-if="(!items || items.length < 1) && !first_loading">
            <td colspan="9">
              <div class="col-12 none-product">
                <i class="fa fa-ban"></i
                >{{ $t("financial.没有符合条件的报表") }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["first_loading", "items", "typeArr"],
  data() {
    return {
      statusClass: {
        1: "tx-warning",
        2: "tx-success",
        9: "tx-danger",
      },
    };
  },
  filters: {
    dateFormat(date) {
      return moment(date, "YYYYMMDD").format("YYYY-MM-DD");
    },
    formatRate(val) {
      //格式化百分比
      if (isNaN(val)) {
        return val;
      } else if (!Number(val)) {
        return val + " %";
      } else {
        return Number(val) < 0 ? `${val} %` : `+ ${val} %`;
      }
    },
    formatProfit(val) {
      // 格式化利润
      if (isNaN(val) || !Number(val)) {
        return val == "-" ? val : "￥ " + val;
      } else {
        return Number(val) < 0 ? `￥ ${val}` : `￥+ ${val}`;
      }
    },
    numClass(val) {
      //数字使用class
      if (isNaN(val) || !Number(val)) {
        return "";
      } else {
        return Number(val) < 0 ? "tx-danger" : "tx-success";
      }
    },
  },
  methods: {
    getOrder(id) {
      if (!this.isSysRights("Profit.getOrders")) return;
      this.$emit("getOrder", id);
    },
    showOperateLog(item) {
      this.$emit("showOperateLog", item);
    },
    modiName(item) {
      this.$emit("modiName", item);
    },
    cancelProfit(item) {
      this.$emit("cancelProfit", item);
    },
    reCalculate(item) {
      this.$emit("reCalculate", item);
    },
    setSkus(item, type) {
      this.$emit("setSkus", item, type);
    },
  },
};
</script>